export class UserDetails {
	id = '';
	name = '';
	email = '';
	phone = '';
	notificationFrequency = 0;
	teamId: Nullable<number> = 0;
	agrilifeAgencyId: Nullable<number> = null;
}
